<template>
  <div class="show-container">
    <div :id="id" style="height: 100%;" v-if="hasData"></div>
    <show-no-data v-else></show-no-data>
  </div>
</template>

<script>
  import eCharts from 'echarts'
  import 'echarts/theme/macarons'
  import analyseUtil from '../analyse-util'
  import ShowNoData from '../show-no-data'
  import {addResizeListener, removeResizeListener} from 'element-ui/src/utils/resize-event'
  export default {
    components: {
      ShowNoData
    },
    props: {
      data: {
        type: 'Object'
      }
    },
    name: 'funnel-config',
    typeCode: '11',
    data() {
      return {
        id: analyseUtil.randomId(),
        myChart: {},
        options: {
          tooltip: {
            show: true,
            formatter: function (params) {
              if (params.data && params.data['value'] > 0) {
                return params.name + '：' + params.data['value'] + '   占比：' + params.data['rate']
              } else {
                return params.name + '：0'
              }
            }
          },
          visualMap: {
            left: '20',
            top: 'bottom',
            color: ['#c23531', '#ca8622', '#f5f5f5'],
            text: ['高', '低'],
            calculable: true
          },
          series: [{
            type: 'map',
            mapType: 'china',
            top: 0,
            bottom: 0,
            itemStyle: {
              normal: {
                opacity: 0.8
              }
            },
            label: {
              emphasis: {
                show: false
              }
            },
            data: null
          }]
        }
      }
    },
    mounted() {
      if (this.hasData) {
        this.loadChart()
        addResizeListener(this.$el, this.resizeListener)
      }
    },
    beforeDestroy() {
      if (this.hasData) {
        removeResizeListener(this.$el, this.resizeListener)
      }
    },
    computed: {
      hasData: function () {
        return this.data.data && this.data.data.length > 0
      }
    },
    methods: {
      resizeListener: function () {
        this.$nextTick(() => {
          if (this.myChart !== null) {
            this.myChart.resize()
          }
        })
      },
      loadChart: function () {
        this.myChart = eCharts.init(document.getElementById(this.id), 'shine')
        this.options.series[0].data = this.data.data
        let total = 0
        let min = null
        let max = null
        for (let i = 0; i < this.data.data.length; i++) {
          total += this.data.data[i].value
          min = min === null || min > this.data.data[i].value ? this.data.data[i].value : min
          max = max === null || max < this.data.data[i].value ? this.data.data[i].value : max
        }
        this.options.visualMap.min = min >= 0 ? 0 : min
        this.options.visualMap.max = max
        for (let i = 0; i < this.data.data.length; i++) {
          let rate = (this.data.data[i].value / total * 100).toFixed(1)
          rate = (rate === '0.0') ? '0.1' : rate
          this.data.data[i].rate = rate + '%'
        }
        this.myChart.setOption(this.options)
        this.myChart.hideLoading()
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/custom/components/page/analyse/show/components/map-config.vue